module.exports = __webpack_public_path__ + "static/bakoba-float-recording-78a2abdfacf41ade004c31176ca93f12.mp4";